import { label } from "@omni/ui/brand/product/label/label.style";

import { LabelContextProvider } from "./context/label.context";
import { LabelComponentProps } from "./label.props";

export const Base = ({
    position,
    type,
    size = "md",
    className,
    children
}: LabelComponentProps) => {
    const { base } = label({ position, type, size });

    return (
        <LabelContextProvider
            position={position}
            type={type}
        >
            <div className={base({ className })}>{children}</div>
        </LabelContextProvider>
    );
};
